export { default as default } from './AfegirBlocImatgeComponent.jsx';